export const fluidCouplingSelection = [
    {
        motorRanking: 2.2,
        models: ['FD0.88A', 'FD0.88A', 'FD0.88A', 'FD0.88A'],       // 1800rpm(4Px60Hz), 1200rpm(6Px60Hz), 1500rpm(4Px50Hz), 1000rpm(6Px50Hz)
        
    },
    {
        motorRanking: 3.7,
        models: ['FD0.88A', 'FD0.88A', 'FD0.88A', 'FD0.88A'],
        
    },
    {
        motorRanking: 5.5,
        models: ['FD0.88A', 'FD0.88A', 'FD0.88A', 'FD0.88A'],
        
    },
    {
        motorRanking: 7.5,
        models: ['FD0.88A', 'FD0.88A', 'FD0.88A', 'FD0.88A'],
        
    },
    {
        motorRanking: 11,
        models: ['FD0.88A', 'FD0.88A', 'FD0.88A', 'FD0.88A'],
        
    },
    {
        motorRanking: 15,
        models: ['FD0.88A', 'FD0.88A', 'FD0.88A', 'FD0.88A'],
        
    },
    {
        motorRanking: 18.5,
        models: ['FD0.88A', 'FD0.88A', 'FD0.88A', 'FD0.88A'],
        
    },
    {
        motorRanking: 22,
        models: ['FD0.88A', 'FD0.88A', 'FD0.88A', 'FD1.0'],
        
    },
    {
        motorRanking: 30,
        models: ['FD0.88A', 'FD0.88A', 'FD0.88A', 'FD1.0'],
        
    },
    {
        motorRanking: 37,
        models: ['FD0.88A', 'FD1.0', 'FD0.88A', 'FD1.0'],
        
    },
    {
        motorRanking: 45,
        models: ['FD0.88A', 'FD1.0', 'FD0.88A', 'FD1.0'],
        
    },
    {
        motorRanking: 55,
        models: ['FD0.88A', 'FD1.0', 'FD0.88A', 'FD1.2'],
        
    },
    {
        motorRanking: 75,
        models: ['FD0.88A', 'FD1.2', 'FD0.88A', 'FD1.2'],
        
    },
    {
        motorRanking: 90,
        models: ['FD0.88A', 'FD1.2', 'FD1.0', 'FD1.2'],
        
    },
    {
        motorRanking: 110,
        models: ['FD0.88A', 'FD1.2', 'FD1.0', 'FD1.2'],
        
    },
    {
        motorRanking: 132,
        models: ['FD1.0', 'FD1.2', 'FD1.0', 'FD1.5'],
        
    },
    {
        motorRanking: 150,
        models: ['FD1.0', 'FD1.2', 'FD1.0', 'FD1.5'],
        
    },
    {
        motorRanking: 160,
        models: ['FD1.0', 'FD1.2', 'FD1.0', 'FD1.5'],
        
    },
    {
        motorRanking: 185,
        models: ['FD1.0', 'FD1.5', 'FD1.0', 'FD1.5'],
        
    },
    {
        motorRanking: 200,
        models: ['FD1.0', 'FD1.5', 'FD1.2', 'FD1.5'],
        
    },
    {
        motorRanking: 220,
        models: ['FD1.0', 'FD1.5', 'FD1.2', 'FD1.5'],
        
    },
    {
        motorRanking: 250,
        models: ['FD1.0', 'FD1.5', 'FD1.2', 'FD1.5'],
        
    },
    {
        motorRanking: 280,
        models: ['FD1.2', 'FD1.5', 'FD1.2', 'FD1.5'],
        
    },
    {
        motorRanking: 300,
        models: ['FD1.2', 'FD1.5', 'FD1.2', 'FD1.5'],
        
    },
    {
        motorRanking: 315,
        models: ['FD1.2', 'FD1.5', 'FD1.2', 'FD1.5'],
        
    },
    {
        motorRanking: 355,
        models: ['FD1.2', 'FD1.5', 'FD1.2', 'FD1.7'],
        
    },
    {
        motorRanking: 375,
        models: ['FD1.2', 'FD1.5', 'FD1.2', 'FD1.7'],
        
    },
    {
        motorRanking: 400,
        models: ['FD1.2', 'FD1.5', 'FD1.2', 'FD1.7'],
        
    },
    {
        motorRanking: 450,
        models: ['FD1.2', 'FD1.7', 'FD1.5', 'FD1.7'],   // ['FD1.2', 'FD1.7', error, 'FD1.7']을 임의 입력한 것임
        
    },
    {
        motorRanking: 500,
        models: ['FD1.5', 'FD1.5', 'FD1.5', 'FD1.7'],   // [error, 'FD1.7', error, 'FD1.7']을 임의 입력한 것임.   
        
    },
];


export const fluidCouplingData = [
    {
        model: 'FD0.88A',
        inertia: 22.4,          // 데이터 없어서 유사값 임의 입력
        weight: 80.0,
    },
    {
        model: 'FD1.0',
        inertia: 53.4,          // 데이터 없어서 유사값 임의 입력
        weight: 120.0,
    },
    {
        model: 'FD1.2',
        inertia: 150.0,         // 데이터 없어서 유사값 임의 입력
        weight: 200.0,
    },
    {
        model: 'FD1.5',
        inertia: 221.0,         // 데이터 없어서 유사값 임의 입력
        weight: 350.0,
    },
    {
        model: 'FD1.7',
        inertia: 464.0,         //kg-m2         // 데이터 없어서 유사값 임의 입력
        weight: 495.0,          // kg
    },
];